// react
import { useState } from 'react';

// types
import { Comment, Pagination } from '../../../../@types';

// router
import { useParams, useSearchParams } from 'react-router-dom';

// hooks
import { useFetch } from '../../../../hooks/useFetch';

// mui
import { Container, Grid, Paper } from '@mui/material';

// ui
import { TableFooter } from '../../../ui/TableFooter/TableFooter';

// tables
import { TableBasicComments } from '../../../tables/basic/TableBasicComments/TableBasicComments';

// utils
import { defaultPagination } from '../../../../utils/defaults';

export const Comments = () => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const { idAccount } = useParams();
	const [searchParams] = useSearchParams();

	// params
	const paramOrder = searchParams.get('order') || 'DESC';
	const paramOrderBy = searchParams.get('orderBy') || 'created';
	const paramPage = Number(searchParams.get('page') || 1);

	// state
	const [pagination, setPagination] = useState<Pagination>({
		...defaultPagination,
		page: paramPage,
	});
	const [comments, setComments] = useState<Comment[]>([]);

	// fetch comments
	const { isLoading: isLoadingComments } = useFetch({
		url: `${process.env.REACT_APP_API_URL}/comments?account=${idAccount}&populate=user&page=${paramPage}&limit=${pagination.perPage}&orderBy=${paramOrderBy}&order=${paramOrder}`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setComments(res.data);
			}
			if (res.pagination) {
				setPagination(res.pagination);
			}
		},
	});

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper>
						<TableBasicComments data={comments} isLoading={isLoadingComments} borderRadius={2} />
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<TableFooter pagination={pagination} />
				</Grid>
			</Grid>
		</Container>
	);
};
